module.exports = __webpack_public_path__ + "static/media/mobile_en.56ae0b05.mp4";